/**
 * All credit goes to Chance (Reach UI), Haz (Reakit) and (fluentui)
 * for creating the base type definitions upon which we improved on
 */
import type { As, ComponentWithAs, RightJoinProps } from '@chakra-ui/react';

type PropsOf<T extends As> = React.ComponentPropsWithRef<T> & {
  as?: As;
};

export function withChakraAs<Props extends object, Component extends As>(
  component: (
    props: RightJoinProps<PropsOf<Component>, Props> & {
      as?: As;
    },
  ) => React.ReactElement | null,
): ComponentWithAs<Component, Props> {
  return component as unknown as ComponentWithAs<Component, Props>;
}
